import { FC } from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import rehypeRaw from 'rehype-raw';
import '../Styles/_markdown.scss';
import { Link } from '@fluentui/react';

type Props = {
    children: string;
};

const CustomLink: FC<any> = ({ node, ...props }) => {
    return <Link {...props} />;
};

export const MarkdownViewer: FC<Props> = ({ children }) => (
    <ReactMarkdown skipHtml components={{ a: CustomLink }} remarkPlugins={[remarkGfm]} rehypePlugins={[rehypeRaw as any]}>
        {children}
    </ReactMarkdown>
);
